import mapbox from 'mapbox-gl';

import { MAPBOX_API_ACCESS_TOKEN } from '@shared/libraries/mapbox';

mapbox.accessToken = MAPBOX_API_ACCESS_TOKEN;
